<template>
  <div>
    <div class="title">
      <span>收款账户管理</span>
    </div>
    <div class="title" v-if="$hasPermission('epay:admin:bankAccount:add')">
      <el-button type="primary" round @click="$router.push({ path: '/epay/bankAccountDetail' })">添加</el-button>
    </div>
    <el-table :data="tableData" style="width: 90%;margin:30px auto;border:1px solid #ccc">
      <el-table-column prop="bankName" label="收款银行"></el-table-column>
      <el-table-column prop="cardNo" label="收款账户"></el-table-column>
      <el-table-column prop="address" label="操作">
        <template v-slot="scope">
          <span class='color-blue' v-if="$hasPermission('epay:admin:bankAccount:modify')" @click="$router.push({ path: '/epay/bankAccountDetail', query: { detail: scope.row } })">编辑</span>
          <span class='color-blue' v-if="$hasPermission('epay:admin:bankAccount:delete')" style="margin:0 5px" @click="deleteItem = scope.row, deleteDialog = true">删除</span>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :close-on-click-modal="false" title="重要提示" :visible.sync="deleteDialog" width="30%">
      <span>是否确认删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary" @click="deleteAccount(deleteItem)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { bankAccountGetAll, bankAccountDel } from '@/api/epay'
export default {
  name: 'BankAccount',
  data () {
    return {
      deleteDialog: false,
      tableData: []
    }
  },
  created () {
    this.getBankAccountAll()
  },
  methods: {
    getBankAccountAll () {
      bankAccountGetAll().then(res => {
        this.tableData = res.data.data
      })
    },
    deleteAccount (row) {
      console.log(row)
      bankAccountDel(row.bankAccountId).then(res => {
        if (res.data.success) {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getBankAccountAll()
          this.deleteDialog = false
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
@deep: ~">>>";

.title {
  height: 57px;
  background: white;
  font-family: "思源黑体 Bold", "思源黑体 Regular", "思源黑体 CN Regular", sans-serif;
  font-weight: 700;
  font-style: normal;
  color: #2e2e2e;
  line-height: 57px;
  border-bottom: 1px solid rgba(234, 234, 234, 1);

  span {
    margin-left: 25px;
  }

  @{deep} .el-button {
    float: right;
    margin: 14px 78px;
  }
}

.add {
  width: 95px;
  height: 30px;
  border-radius: 30px;
  background: rgba(20, 115, 230, 1);
  color: #f4f4f4;
  border: none;
  float: right;
  margin: 13px 50px;
}
</style>
